const resolveText = (value: unknown): string => String(value || '').trim();

export const resolveQuotationHotelCode = (hotel: any): string => {
  const provider = resolveText(
    hotel?.provider ||
    hotel?.source ||
    hotel?.supplier ||
    hotel?.provider_name ||
    hotel?.providerName
  );
  const providerHotelId = resolveText(
    hotel?.providerHotelId ||
    hotel?.provider_hotel_id
  );
  if (provider && providerHotelId) {
    return `${provider}:${providerHotelId}`;
  }

  const hotelId = resolveText(
    hotel?.hotelId ||
    hotel?.hotel_id ||
    hotel?.id
  );
  if (provider && hotelId) {
    return `${provider}:${hotelId}`;
  }

  const directCode = resolveText(
    hotel?.hotelCode ||
    hotel?.hotel_code
  );
  if (directCode.includes(':')) return directCode;

  const hotelRef = resolveText(
    hotel?.hotelRef ||
    hotel?.hotel_ref ||
    hotel?.ref
  );
  if (hotelRef.includes(':')) return hotelRef;

  if (directCode) return directCode;
  if (hotelRef) return hotelRef;
  if (hotelId) return hotelId;

  return '';
};
